export default "/images/42ab5d4a6c747f46eb86538ed72e91c4.avif";